import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BreadCrumbContainer from '../common/breadcrumbContainer/breadcrumbContainer';

import TimeCardsContainer from './TimeCardsContainer';

import { getTimesFromDisplayTimeRange } from './timecard.helpers';

import { getUnions } from '../unions/state/unions.actions';
import { getSageShifts } from '../sage/state/sage.actions';
import TimeTracking from '../state/timeTracking';

import Permissions from '../auth/Permissions';

const CRUMBS = [{
  text: 'Time Cards',
  icon: 'timecard',
}, {
  text: 'My Cards',
}];
export default function Timecards() {
  const dispatch = useDispatch();
  const selectedDivisions = useSelector((state) => state.settings.selectedDivisions);
  const { timeRange } = useSelector((state) => state.timecards);

  useEffect(() => {
    dispatch(getUnions());
  }, []);

  useEffect(() => {
    dispatch(getSageShifts({ divisionIds: Array.from(selectedDivisions) }));
  }, [selectedDivisions]);

  useEffect(() => {
    const payload = {
      getRunningTasks: true,
      userId: Permissions.id,
    };
    const { startTime: ourStart, endTime: ourEnd } = getTimesFromDisplayTimeRange(timeRange);
    payload.startTime = ourStart;
    payload.endTime = ourEnd;
    payload.getCardDetails = true;
    dispatch(TimeTracking.getTimeEntries(payload));
  }, [timeRange]);

  return (
    <BreadCrumbContainer
      crumbs={CRUMBS}
      bodyStyle={{ marginTop: 0 }}
      redesignCrumbStyle={{ marginBottom: 0 }}
    >
      <TimeCardsContainer
        isIndividual
        userId={Permissions.id}
      />
    </BreadCrumbContainer>
  );
}
